module.exports = __webpack_public_path__ + "img/s7.0be7046f.svg";